import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header"

const addAssetSetting = (asset_series,assets_type) => {
  return axios.post(API + "company/company-settings/", {
    asset_series,
    assets_type

  
  },{headers: authHeader(),});
};
const AddAssetSettingService = {
    addAssetSetting,
    
  };
  export default AddAssetSettingService;